import { render, staticRenderFns } from "./MakeSureTheOrder.vue?vue&type=template&id=05633167&"
import script from "./MakeSureTheOrder.vue?vue&type=script&lang=js&"
export * from "./MakeSureTheOrder.vue?vue&type=script&lang=js&"
import style0 from "./MakeSureTheOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports